import BookingsModule from "./bookingsModule";
import BookingsReducer from "./redux/bookingsReducer";
import BookingsSaga from "./redux/bookingsSagas";

export default {
  Component: BookingsModule,
  moduleName: "bookings",
  saga: BookingsSaga(),
  reducer: BookingsReducer
};
